/* Footer1.js */

import React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import Strings from '../../translations/Translations';

export default function Footer1() {

  return (
    <footer className="text-center text-lg-start text-muted border-top mt-5 bg-footer">
      <Container>
        <ul className="nav justify-content-center py-3">
          <li className="nav-item"><Link className="nav-link px-2 text-muted" to="/dashboard">{Strings('dashboard')}</Link></li>
          <li className="nav-item"><Link className="nav-link px-2 text-muted" to="/create">{Strings('create_yours')}</Link></li>
          <li className="nav-item"><Link className="nav-link px-2 text-muted" to="/about">{Strings('about')}</Link></li>
        </ul>
      </Container>

      <div className="text-center p-3 ">
        {`© ${new Date().getFullYear()} Copyright: `}
        <a className="text-reset fw-bold" href="https://photozig.com" target="_blank" rel="noopener noreferrer">Photozig Inc.</a>
      </div>
    </footer>
  );
}
